<template>
  <div class="EnterpriseBasicDatadata">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="Files-top">
          <div class="ic-left">
            <span>尖峰平谷</span>
          </div>
          <div class="btns">
            <el-button @click="exportList" type="primary" class="last-el-button">导出</el-button>
          </div>
        </div>
        <div class="search-input-btn" style="width:100%">
          <div class="input-small mr-20">
            <span>开始时间：</span>
            <el-date-picker v-model="bgTime" type="date" placeholder="选择时间" align="right"
              :picker-options="pickerOptions"> </el-date-picker>
          </div>
          <div class="input-small ">
            <span>结束时间：</span>
            <el-date-picker v-model="endTime" type="date" placeholder="选择时间" align="right"
              :picker-options="pickerOptions"> </el-date-picker>
          </div>
          <el-button type="primary" plain @click="getList" class="search-btn">查询</el-button>
        </div>
        <div class="mycharts">
          <div class="charts-left">
            <div id="chart_example" :style="{height:heights+'px'}"></div>
          </div>
          <div class="charts-right">
            <div id="chart_example2" :style="{height:heights+'px'}"></div>
          </div>
        </div>
        <div class="mytable">
          <el-table :data="tableData11" style="width: 100%" :height="tabheights">
            <el-table-column label="序号" width="90" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="variableName" label="名称" width="180"> </el-table-column>
            <el-table-column prop="variableType" label="类型" width="180">
              <template slot-scope="scope">{{ scope.row.variableType | company }}</template>
            </el-table-column>
            <el-table-column prop="energyTotal" label="电量（KWh）"> </el-table-column>
            <el-table-column prop="energyChargeTotal" label="电费"></el-table-column>
          </el-table>
        </div>
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>

      </div>
    </div>
    <!-- <el-row>
      <el-col :span="4" style="position: relative;border-right:1px solid #ccc" v-show="flag">
        <span class="el-icon-d-arrow-left" v-show="flag" @click="
            flag = !flag;
            num = 24;
          "></span>
        <span style="padding: 10px;display: block;">
          <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
        </span>
        <span v-show="false">{{unitId.id}}</span>
        <div class="left" style="width: 100%;">
          <el-tree class="filter-tree" show-checkbox :data="treeList" :props="defaultProps" highlight-current
            :filter-node-method="filterNode" ref="tree" @check-change='tree_fn' auto-expand-parent>
            <template #default="{ node }">
              <span class="custom-tree-node">
                <img src="../../../public/static/image/elTree/1.9.png" v-if="node.data.Content.Category=='Organization'" />
                <img src="../../../public/static/image/elTree/2.1.png" v-else />

                {{ node.data.Content.Name }}
              </span>
            </template>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="num" style="position: relative;padding-left:20px">
        <span class="el-icon-d-arrow-right" v-show="!flag" @click="
            flag = !flag;
            num = 19;"></span>
        <span style="margin:9px;display:block;">
          <span>
            日期:
            <el-date-picker v-model="value1" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
              style="width:260px;" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </span>
          <el-button icon="el-icon-search" @click="getList" style="margin-left:15px;" type="primary"
            plain>查看</el-button>
          <el-button icon="el-icon-upload" @click="exportList" type="primary" plain>导出</el-button>
        </span>

        <el-row>
          <el-col :span="10">
            <div id="chart_example" :style="{height:heights-100+'px'}"></div>
          </el-col>
          <el-col :span="14">
            <div id="chart_example2" :style="{height:heights-100+'px'}"></div>
          </el-col>
        </el-row>
       
        <div class="mytable">
          <el-table :data="tableData11" style="width: 100%" height="250">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column prop="variableName" label="名称" width="180"> </el-table-column>
            <el-table-column prop="variableType" label="类型" width="180">
              <template slot-scope="scope">{{ scope.row.variableType | company }}</template>
            </el-table-column>
            <el-table-column prop="energyTotal" label="电量（KWh）"> </el-table-column>
            <el-table-column prop="energyChargeTotal" label="电费"></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row> -->
  </div>
</template>
<script>
  // import { ElectricAnalyse } from "@/utils/request";

  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import {getStatisticsPG} from "../../api/rateTemplate";
  import {getReadDeviceTree} from "../../api/abbNewApi";
  import * as echarts from 'echarts';
  // import { parseTime } from "@/utils";
  import $ from 'jquery';
  var myChart,myChart2;
  export default {
    components: {
      elUnitTree,
    },
    data () {
      return {
        loading: false,
        tableData11: [],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        treeList: [],
        error: true,
        // today: parseTime(new Date(), "{m}-{d}"),
        today: "",
        // value1: [parseTime(new Date().getTime()-86400000,'{y}-{m}-{d}'), parseTime(new Date(),'{y}-{m}-{d}')],
        value1: [new Date(),new Date()],
        bgTime: new Date().getTime()-86400000,
        endTime: new Date(),
        num: 19,
        tempId: [],
        flag: true, //显示树形
        filterText: "",
        heights: document.getElementById('app').clientHeight-550,
        tabheights: document.getElementById('app').clientHeight-680,
        tableData: [
          {
            Electricity_1000: 1152,
            Electricity_351: 288,
            Electricity_352: 288,
            Electricity_353: 288,
            Electricity_354: 288,
            Tariff_1000: 1440,
            Tariff_351: 316.8,
            Tariff_352: 345.6,
            Tariff_353: 374.39,
            Tariff_354: 403.19
          }
        ],
        data: JSON.parse(localStorage.getItem('getReadDeviceTree')),
        defaultProps: {
          label: "Content",
          children: 'ChildDatas'
        },
        ids: '',
        columns: [{
          name: "总电量",
          key: "Electricity_1000",
        },{
          name: "尖电量",
          key: "Electricity_351",
        },{
          name: "峰电量",
          key: "Electricity_352",
        },{
          name: "平电量",
          key: "Electricity_353",
        },{
          name: "谷电量",
          key: "Electricity_354",
        },
        {
          name: "尖电费",
          key: "Tariff_351",
        },{
          name: "峰电费",
          key: "Tariff_352",
        },{
          name: "平电费",
          key: "Tariff_353",
        },{
          name: "谷电费",
          key: "Tariff_354",
        },{
          name: "总电费",
          key: "Tariff_1000",
        }
        ],

        columns1: [{
          name: "总电量",
          key: "Electricity_1000",
        },{
          name: "尖电量",
          key: "Electricity_351",
        },{
          name: "峰电量",
          key: "Electricity_352",
        },{
          name: "平电量",
          key: "Electricity_353",
        },{
          name: "谷电量",
          key: "Electricity_354",
        }
        ],
        columns2: [
          {
            name: "总电费",
            key: "Tariff_1000",
          },
          {
            name: "尖电费",
            key: "Tariff_351",
          },{
            name: "峰电费",
            key: "Tariff_352",
          },{
            name: "平电费",
            key: "Tariff_353",
          },{
            name: "谷电费",
            key: "Tariff_354",
          }
        ],
        option: {
          title: {
            text: '占比分析',
            textStyle: {
              color: '#333',
              fontStyle: 'normal',
              fontWeight: '400',
              fontFamily: 'sans-serif',
              fontSize: 15
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}(kWh)  ({d}%)'
          },
          legend: {
            type: 'scroll',
            top: 18
          },
          "series": [

            {
              name: '电量',
              type: 'pie',
              radius: ['50%','70%'],
              label: {
                position: 'inner',
                show: false
              },
              "data": [{
                "name": "总电量",
                "value": "12"
              },{
                "name": "尖电量",
                "value": "12"
              },{
                "name": "峰电量",
                "value": "12"
              },{
                "name": "平电量",
                "value": "12"
              },{
                "name": "谷电量",
                "value": "12"
              }],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                normal: {
                  label: {
                    show: true,
                    formatter: '{b} : {c} ({d}%)'
                  },
                  labelLine: {show: true}
                }
              }
            },
            {
              name: '电费',
              type: 'pie',
              selectedMode: 'single',
              radius: [0,'40%'],
              label: {
                normal: {
                  position: 'inner',
                  show: false
                }
              },
              "data": [{
                "name": "总电费",
                "value": "12"
              },{
                "name": "尖电费",
                "value": "12"
              },{
                "name": "峰电费",
                "value": "12"
              },{
                "name": "平电费",
                "value": "12"
              },{
                "name": "谷电费",
                "value": "12"
              },],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                normal: {
                  label: {
                    show: true,
                    formatter: '{b} : {c} ({d}%)'
                  },
                  labelLine: {show: true}
                }
              }
            },
          ]
        },
        option2: {
          title: {
            text: '累计趋势',
            textStyle: {
              color: '#333',
              fontStyle: 'normal',
              fontWeight: '400',
              fontFamily: 'sans-serif',
              fontSize: 15
            }
          },
          // color: ['#c23531', '#2f4554', '#61a0a8'],
          // color: ['#c23531', '#2f4554', '#61a0a8','red'],

          tooltip: {
            trigger: 'axis',
            formatter: '{b}: {c}(kWh) '
          },
          dataZoom: [
            {
              show: false,
            },
            {
              type: 'inside',
            }
          ],
          "xAxis": {"data": ["早","中","晚"]},
          "series": [
            {
              type: 'bar',
              "data": [{"name": "早","value": "0.00"},{"name": "中","value": "0.00"},{"name": "晚","value": "0.00"}],
              itemStyle: {
                normal: {
                  color: function(params) {
                    let colorList=[
                      // 每根颜色顺序
                      '#5c7bd9',
                      '#91cc75',
                      '#fedb5f',
                      "#fb6d6d",
                      "#7ed3f4",
                      "#40b27d",
                      "#ff915a",
                      "#a969c6",
                    ];
                    return colorList[params.dataIndex];
                  }
                }
              }
            }],
          yAxis: {
            type: 'value',axisLabel: {
              formatter: function(value,index) {

                return value.toFixed(1);

              }
            }
          }
        }

      };
    },


    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },

    },
    created () {
      // this.treeList = JSON.parse(localStorage.getItem('treeList'))
      //       console.log("树形",this.treeList);
    },
    computed: {

      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
    },
    mounted () {
      this.init();


    },
    methods: {
      //树形结构选择
      checkFun (val) {
        // this.nowVirtualDevice = val
        this.tempId=[]
        val.forEach(item => {
          this.tempId.push(item.no)
        })
        this.getList()
      },
      //下载excel表格
      exportList () {
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader=[];
          var filterVal=[];
          for(const key in this.columns) {
            if(Object.hasOwnProperty.call(this.columns,key)) {
              tHeader.push(this.columns[key].name);
              filterVal.push(this.columns[key].key);
            }
          }

          const list=this.tableData;
          const data=this.formatJson(filterVal,list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: '数据',
            autoWidth: true,
            bookType: 'xlsx'
          });
        });
      },
      formatJson (filterVal,jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          return v[j];
        }));
      },


      //获取数据
      getList () {
        if(this.tempId.length==0) {
          this.$message({
            message: '请选择设备',
            type: 'warning'
          });
          return
        }
        if(!this.bgTime||!this.endTime) {
          this.$message({message: '请选择时间',type: 'warning'});
          return
        }

        var bgTimeStr=typeof this.bgTime=='number'? this.bgTime:this.bgTime.getTime()
        var endTimeStr=typeof this.endTime=='number'? this.endTime:this.endTime.getTime()
        this.loading=true
        // var endTimeStr=new Date(this.value1[1]).getFullYear()+'-'+(new Date(this.value1[1]).getMonth()+1)+'-'+new Date(this.value1[1]).getDate()
        var d={
          "deviceNos": this.tempId,
          "bgTime": bgTimeStr,
          "endTime": endTimeStr
        };


        getStatisticsPG(d).then(data => {
          this.loading=false
          if(data.code!=200) {
            this.$message({
              message: data.message,
              type: 'warning'
            });

            return
          }
          let res=data.data
          for(let i in res.energyCollect) {
            res.energyCollect['Electricity_'+i]=res.energyCollect[i]
          }
          for(let i in res.chargeCollect) {
            res.chargeCollect['Tariff_'+i]=res.chargeCollect[i]
          }

          var Response=Object.assign(res.energyCollect,res.chargeCollect);
          delete Response['351']
          delete Response['352']
          delete Response['353']
          delete Response['354']
          delete Response['1000']
          for(const key in Response) {
            if(Object.hasOwnProperty.call(Response,key)) {
              Response[key]=parseInt(Response[key]*100)/100
            }
          }
          this.tableData11=res.collectList
          // console.log("Response",Response);
          this.tableData=[Response];
          // console.log("this.tableData",this.tableData);
          var b=[];
          var name=[];
          var val=[]
          this.columns.map((v,i) => {
            if(i&&i<9) {
              name.push(v.name)
              val.push(this.tableData[0][v.key])
              b.push({
                name: v.name,
                value: this.tableData[0][v.key]
              })
            }

          });

          //饼图
          var b1=[]
          var b2=[]
          for(let i=0;i<4;i++) {
            b1.push(b[i])
          }
          for(let i=4;i<b.length;i++) {
            b2.push(b[i])
          }
          this.option.series[0].data=b1;
          this.option.series[1].data=b2;
          myChart.setOption(this.option,true);

          // 柱状图
          this.option2.xAxis.data=name;
          this.option2.series[0].data=val;
          myChart2.setOption(this.option2,true);

        }).catch(() => {
          this.loading=false
        });



      },

      // 树形筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.name.indexOf(value)!==-1;
      },
      // 初始化图表
      init () {
        myChart=echarts.init(document.getElementById('chart_example'));
        myChart2=echarts.init(document.getElementById('chart_example2'));
        // legend: {
        //     data: d,
        //     top: this.heights - 150
        //   }, 

        myChart.setOption(this.option);
        myChart.resize();
        myChart2.setOption(this.option2);
        myChart2.resize();
        $(window).resize(function() {
          myChart.resize();
          myChart2.resize();
        });
      }

    },
    //过滤器
    filters: {
      //费率类型 ELECTRIC(电)  WATER(水) GAS(气)
      energyType (val) {
        if(val=='ELECTRIC') {
          return "电"
        } else if(val=='WATER') {
          return "水"
        } else {
          return "气"
        }
      },
      //单位类型
      company (val) {
        if(val=='351') {
          return "尖"
        } else if(val=='352') {
          return "峰"
        } else if(val=='353') {
          return "平"
        } else if(val=='354') {
          return "谷"
        } else if(val=='1000') {
          return "总"
        }
      },
      //阶梯名称
      sectionNameFun (val) {
        if(val=='第1阶梯') {
          return "第一阶梯"
        } else if(val=='第2阶梯') {
          return "第二阶梯"
        } else if(val=='第3阶梯') {
          return "第三阶梯"
        } else {
          return val
        }
      },
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>
<!-- <style>
  .name-wrapper {
    background: #1890ff;
    color: #fff;
  }
</style> -->
<style lang="scss" scoped>
  .EnterpriseBasicDatadata {

    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>